<template>
  <div class="container">
    <main class="main-content">
      <article class="main">
        <QuickLink />
        <section class="list">
          <div class="scroll-np">
            <div class="tbl">
              <table>
                <colgroup>
                  <col style="width: 18%;">
                  <col style="width: 13%;">
                  <col style="width: 28%">
                  <col style="width: 26%;">
                  <col style="width: 16%;">
                </colgroup>
                <thead>
                  <tr>
                    <th>연월</th>
                    <th>ATM</th>
                    <th>지점명</th>
                    <th>점검날짜</th>
                    <th>점검기간</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="data in dataList" :key="data.atmMntcSchdNum">
                    <td>{{data.workYymm}}</td>
                    <td>{{data.prchChnlAfliNum}}</td>
                    <td>{{data.atmNm}}</td>
                    <td>{{formatDate(data.workDt)}}</td>
                    <td>{{data.chckPerd}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </article>
    </main>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import DxDateBox from 'devextreme-vue/date-box'
import {formatMessage} from 'devextreme/localization'

import QuickLink from '@/components/QuickLink.vue'

export default {
  name: 'Home',
  components: {
    DxDateBox,
    QuickLink
  },
  data () {
    const vm = this
    return {
      jQuery,
      databyAtmMntcChcekCd: [],
      prefixUrl: '/api/purchase/customerCare',
      pagingData: {
        skip: 0,
        rowCount: 40
      },
      searchData: {
        year: moment().format('YYYY'),
        month: moment().format('MM'),
        term: '',
        condition: '',
        conditionText: ''
      },
      dataList: [],
      cacheSearchData: null,
      cachePagingData: null
    }
  },
  computed: {
    userId () {
      return window.$store.getters['Login/getUserId']
    }
  },
  watch: {
    '$route' (from, to) {
      this.handleSearch()
    }
  },
  methods: {
    formatMessage: formatMessage,
    async handleSearch (buttonClick) {
      if (buttonClick) {
        this.dataList = []
        this.pagingData.skip = 0
      }

      const params = {
        ...this.searchData,
        skip: this.pagingData.skip,
        take: this.pagingData.rowCount,
        condition: '2',
        conditionText: this.userId,
        mobile: 'mobile'
      }

      const {data} = await Vue.httpClient.get('/api/purchase/customerCare/atmMntcSchdList', {params: params})
      if (data.result.list.length > 0) {
        data.result.list.forEach(obj => {
          this.dataList.push(obj)
        })
        this.pagingData.skip = this.pagingData.skip + this.pagingData.rowCount
      }
    },
    handleUpdate (data) {
      this.$router.push({name: 'AtmMntcSchdUpdate', params: { data }})
    },
    goMenu (menuUrlAddr) {
      this.$router.push({path: menuUrlAddr})
    },
    formatDate (value) {
      if (value) {
        return moment(value).format('yyyy-MM-DD')
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.handleSearch()
    /*
    window.onscroll = () => {
      if ($(window).scrollTop() >= $(document).height() - $(window).height()) {
        this.handleSearch()
      }
    }
    */
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home.vue